import type { ReactNode } from "react";

export const GridRow = ({ children }: { children?: ReactNode }) => {
	return (
		<div className="contents group" role="row">
			{children}
		</div>
	);
};
